"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIGNMENT_RULES = exports.JOB_POSSIBLE_TO_CONFIGURE = exports.STEP_TYPE = exports.STEP_SCOPE = exports.WORKFLOW_TYPE = void 0;
var WORKFLOW_TYPE;
(function (WORKFLOW_TYPE) {
    WORKFLOW_TYPE["DELIVERY_LOADING"] = "DELIVERY_LOADING";
    WORKFLOW_TYPE["DELIVERY_SUCCESSFUL"] = "DELIVERY_SUCCESSFUL";
    WORKFLOW_TYPE["DELIVERY_UNSUCCESSFUL"] = "DELIVERY_UNSUCCESSFUL";
    WORKFLOW_TYPE["DELIVERY_PARTIALLY_SUCCESSFUL"] = "DELIVERY_PARTIALLY_SUCCESSFUL";
    WORKFLOW_TYPE["DELIVERY_CHECKOUT"] = "DELIVERY_CHECKOUT";
    WORKFLOW_TYPE["VAN_SALES_LOADING"] = "VAN_SALES_LOADING";
    WORKFLOW_TYPE["VAN_SALES_CHECKOUT"] = "VAN_SALES_CHECKOUT";
})(WORKFLOW_TYPE || (exports.WORKFLOW_TYPE = WORKFLOW_TYPE = {}));
var STEP_SCOPE;
(function (STEP_SCOPE) {
    STEP_SCOPE["GLOBAL"] = "GLOBAL";
    STEP_SCOPE["TEAM"] = "TEAM";
    STEP_SCOPE["SINGLE_TEAM"] = "SINGLE_TEAM";
    STEP_SCOPE["MOBILE_USER"] = "MOBILE_USER";
    STEP_SCOPE["SINGLE_MOBILE_USER"] = "SINGLE_MOBILE_USER";
})(STEP_SCOPE || (exports.STEP_SCOPE = STEP_SCOPE = {}));
/**
 * The different type of steps
 */
var STEP_TYPE;
(function (STEP_TYPE) {
    STEP_TYPE["ACTIVITY"] = "ACTIVITY";
    STEP_TYPE["TIMER"] = "TIMER";
    STEP_TYPE["NOTIFICATION"] = "NOTIFICATION";
    STEP_TYPE["TRANSFORMATION"] = "TRANSFORMATION";
    STEP_TYPE["STREAM"] = "STREAM";
    STEP_TYPE["INTEGRATION"] = "INTEGRATION";
    STEP_TYPE["CREATE_REPORT"] = "CREATE_REPORT";
    STEP_TYPE["CREATE_PREDICTION"] = "CREATE_PREDICTION";
    STEP_TYPE["SHARE_QUERY_RESULTS"] = "SHARE_QUERY_RESULTS";
    STEP_TYPE["USE_PREDICTION"] = "USE_PREDICTION";
    STEP_TYPE["START_WORKFLOW"] = "START_WORKFLOW";
    STEP_TYPE["UPDATE_QUERY_ATTRIBUTES"] = "UPDATE_QUERY_ATTRIBUTES";
    STEP_TYPE["MAINTENANCE"] = "MAINTENANCE";
    STEP_TYPE["SCRIPT"] = "SCRIPT";
    STEP_TYPE["HTTP_REQUEST"] = "HTTP_REQUEST";
    STEP_TYPE["CREATE_ITEM"] = "CREATE_ITEM";
    STEP_TYPE["EDIT_ITEM"] = "EDIT_ITEM";
    STEP_TYPE["EXPORT_ACTIVITY_REPORT_PDF"] = "EXPORT_ACTIVITY_REPORT_PDF";
    STEP_TYPE["UPLOAD_IMAGE_TO_HASTY"] = "UPLOAD_IMAGE_TO_HASTY";
    STEP_TYPE["MIGRATION"] = "MIGRATION";
    STEP_TYPE["WEBHOOK"] = "WEBHOOK";
    STEP_TYPE["TRIGGER"] = "TRIGGER";
})(STEP_TYPE || (exports.STEP_TYPE = STEP_TYPE = {}));
exports.JOB_POSSIBLE_TO_CONFIGURE = Object.values(STEP_TYPE).filter((s) => ![
    STEP_TYPE.ACTIVITY, // this one is an activity, not a job really
    STEP_TYPE.MAINTENANCE, // used in maintenance default workflows
    STEP_TYPE.SHARE_QUERY_RESULTS, // used for Nestle in v2, not sure used anymore in v3
].includes(s));
var ASSIGNMENT_RULES;
(function (ASSIGNMENT_RULES) {
    ASSIGNMENT_RULES["NONE"] = "NONE";
    ASSIGNMENT_RULES["MANUAL"] = "MANUAL";
    ASSIGNMENT_RULES["AUTO"] = "AUTO";
    /**
     * @deprecated use META_EXPRESSION
     */
    ASSIGNMENT_RULES["AUTOMATED"] = "AUTOMATED";
    ASSIGNMENT_RULES["META_EXPRESSION"] = "META_EXPRESSION";
})(ASSIGNMENT_RULES || (exports.ASSIGNMENT_RULES = ASSIGNMENT_RULES = {}));
